import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import MainMenu from "../../_components/MainMenu";
import MainFooter from "../../_components/MainFooter";
//import { branchService } from "../../_services/branch.service";
import { menuService } from "../../_services/menu.service";
import { emailService } from "../../_services/email.service";
import queryString from "query-string";
import { postService } from "../../_services/post.service";

const ResetPassword = () => {
  const [user, setUser] = useState({});
  const [menu, setMenu] = useState({});
  const [topbarMenu, setTopbarMenu] = useState({});
  const [branches, setBranches] = useState([]);
  //const [error, setError] = useState();
  const [values, setValues] = useState({});
  const location = useLocation();
  const { expire } = queryString.parse(location.search);

  const handleChange = (e) => {
    const inputValue = { [e.target.name]: e.target.value };
    setValues((values) => ({
      ...values,
      ...inputValue,
    }));
  };

//   const handleSubmit = async (e) => {
//     try {
//       e.preventDefault();
//       if (expire) {
//         if (!values.password || values.password !== values.confirmPassword)
//           return;
//         const { message } = await emailService.changePassword({
//           ...values,
//           token: expire,
//         });
//         alert(message);
//       } else {
//         if (!values.email) return;
//         const { message } = await emailService.forgotPassword(values);
//         alert(message);
//       }
//     } catch (error) {
//       alert(error);
//     }
//   };

const handleSubmit = async (e) => {
    // try {
    //   e.preventDefault();

    //   console.log(values)
    //   if (!values.email) {
    //     alert('Please enter your email address');
    //     return;
    //   }
    //   // Call the API to send password reset link
    //   const response = await emailService.forgotPassword(values.email);
    //   // Show success or error message based on the response
    //   alert(response.message);
    // } catch (error) {
    //   // Handle any unexpected errors
    //   console.error(error);
    //   alert('An unexpected error occurred');
    // }

    e.preventDefault();
    //const { email } = values;
    const response = await emailService.forgotPassword(values.email);
    alert(response.message); 
  };
  

  useEffect(() => {
    (async () => {
      try {
        const branches = await postService.getBranches('branch','branches').then(branchesData => branchesData.items);
        const menu = await menuService.getMenuByName('default');
        const topbarMenu = await menuService.getMenuByName("Topbar");

        

        setMenu(menu);
        setBranches(branches);
        setTopbarMenu(topbarMenu);
      } catch (error) {}
    })();
  }, []);

  useEffect(() => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      setUser(user);
    } catch {
      setUser({});
    }
  }, []);

//   console.log(branches)

  if (expire) {
    return (
      <>
        <MainMenu user={user} menu={menu} topbarMenu={topbarMenu} />
        <div className="jumbotron page-title py-5">
          <div className="container">
            <h1 className="text-white bolder text-center">Change Password</h1>
          </div>
        </div>
        <section>
          <div className="container">
            <div className="row mb-5 justify-content-md-center">
              <div className="col-lg-6 col-sm-12">
                <div className="row">
                  <div className="col-12">
                    <form onSubmit={handleSubmit}>
                      <div className="form-group col-l2">
                        <label htmlFor="">Password</label>
                        <input
                          name="password"
                          value={values?.password ?? ""}
                          onChange={handleChange}
                          type="password"
                          className={`form-control form-control-lg ${
                            !values.password && "is-invalid"
                          }`}
                        />
                        {!values.password && (
                          <div className="invalid-feedback">
                            Password is required.
                          </div>
                        )}
                      </div>
                      <div className="form-group col-l2">
                        <label htmlFor="">Confirm Password</label>
                        <input
                          name="confirmPassword"
                          value={values?.confirmPassword ?? ""}
                          onChange={handleChange}
                          type="password"
                          className={`form-control form-control-lg ${
                            (!values.confirmPassword ||
                              values.confirmPassword !== values.password) &&
                            "is-invalid"
                          }`}
                        />
                        {(!values.confirmPassword ||
                          values.confirmPassword !== values.password) && (
                          <div className="invalid-feedback">
                            Password not match
                          </div>
                        )}
                      </div>
                      <div className="form-group">
                        <button
                          type="submit"
                          className="btn btn-primary btn-lg btn-block mt-3 p-2"
                        >
                          Change Password
                        </button>
                        <div className="text-center mt-3">
                          <a href="/" className="text-primary">
                            <small>Back to Login</small>
                          </a>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <MainFooter branches={branches} />
      </>
    );
  }

  return (
    <>
      <MainMenu user={user} menu={menu} topbarMenu={topbarMenu} />
      <div className="jumbotron page-title py-5">
        <div className="container">
          <h1 className="text-white bolder text-center">Password Reset</h1>
        </div>
      </div>
      <section>
        <div className="container">
          <div className="row mb-5 justify-content-md-center">
            <div className="col-lg-6 col-sm-12">
              <h3 className="font-weight-lighter mb-5 line-height-md text-center">
                Enter the email address associated with your account and we will
                send you a link to reset your password.
              </h3>
              <div className="row">
                <div className="col-12">
                  <form onSubmit={handleSubmit}>
                    <div className="form-group col-l2">
                      <label htmlFor="">Email</label>
                      <input
                        name="email"
                        value={values?.email ?? ""}
                        onChange={handleChange}
                        type="text"
                        className={`form-control form-control-lg ${
                          !values.email && "is-invalid"
                        }`}
                      />
                      {!values.email && (
                        <div className="invalid-feedback">
                          Email is required.
                        </div>
                      )}
                    </div>
                    <div className="form-group">
                      <button
                        type="submit"
                        className="btn btn-primary btn-lg btn-block mt-3 p-2"
                      >
                        Reset Password
                      </button>
                      <div className="text-center mt-3">
                        <a href="/" className="text-primary">
                          <small>Back to Login</small>
                        </a>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <MainFooter branches={branches} />
    </>
  );
};

export default ResetPassword;